import { useTranslation } from "react-i18next";
import {
  InfoField,
  MetadataSection,
} from "~/molecules/DocumentMetadataSections";
import { type DocumentReleaseDetails } from "~/api/types";
import { DueDateCell } from "~/molecules/DueDateCell";

interface Props {
  release: DocumentReleaseDetails;
}

export default function WorkflowDates({ release }: Props) {
  const { t } = useTranslation();

  const workflowStartedAt = release.artifact.stepInstances[0]?.createdAt;
  const workflowEndedAt = release.artifact.publishedAt;

  return (
    <MetadataSection title={t(($) => $.commons.document.reviewDates)}>
      <div className="grid grid-cols-2">
        <InfoField label={t(($) => $.commons.document.reviewFrom)}>
          <DueDateCell
            dueDate={release.artifact.reviewFrom}
            className={workflowStartedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowStartedAt === undefined}
          />
        </InfoField>
        <InfoField label={t(($) => $.commons.document.reviewTo)}>
          <DueDateCell
            dueDate={release.artifact.reviewTo}
            className={workflowEndedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowEndedAt === null}
          />
        </InfoField>
      </div>
    </MetadataSection>
  );
}
